import * as React from 'react';
import Button from '../../../../../../components/common/Button';
import { downloadFile } from 'src/utils/downloadHelper';
import './SaveForLaterConfirm.scss';
import { currencyFormatter } from 'src/utils/currencyFormatter';

interface ISaveLaterConfirm {
  handleSaveForLater: (e:any)=>void;
  t?: any;
}
const SaveForLaterConfirm: React.FC<ISaveLaterConfirm> = props => {
  const {
    handleSaveForLater,
    t
  } = props;

  return (
    <div className="rp-returns-table">
        <div className="d-flex align-items-center col-12">
          <p><strong>{t('myReturns.saveForLaterConfirmAlt')}</strong></p>
        </div>

      <div className="container-fluid">
      <button className="login">
          <Button
            buttonClass="primary-button login-button"
            label={t('myReturns.continueBtn')}
            action={handleSaveForLater}
          />
        </button>
      </div>
    </div>
   
  );
};

export default SaveForLaterConfirm;
